export default function Differentials() {
  const differentials = [
    {
      icon: 'ri-shield-check-line',
      title: 'Conformidade Legal Total',
      description: 'Todas as operações são estruturadas com base na legislação vigente, com parecer jurídico e acompanhamento de especialistas tributários.'
    },
    {
      icon: 'ri-team-line',
      title: 'Equipe Multidisciplinar',
      description: 'A Feenex é amparada pelo time da Monetali, composto por analistas, advogados tributaristas, contadores e especialistas financeiros com décadas de experiência no mercado.'
    },
    {
      icon: 'ri-file-shield-2-line',
      title: 'Transparência Absoluta',
      description: 'Documentação completa de todas as operações, com relatórios detalhados e auditoria independente disponível a qualquer momento.'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Suporte Dedicado',
      description: 'Atendimento personalizado com nosso gestor de conta exclusivo para acompanhar sua empresa em todas as etapas do processo. A Monetali também está conosco nesse suporte.'
    },
    {
      icon: 'ri-lock-2-line',
      title: 'Segurança Jurídica',
      description: 'Operações respaldadas por pareceres jurídicos robustos e estruturas testadas e aprovadas por órgãos reguladores.'
    },
    {
      icon: 'ri-bar-chart-box-line',
      title: 'Resultados Mensuráveis',
      description: 'Acompanhamento de indicadores de performance com relatórios periódicos demonstrando a economia tributária alcançada.'
    }
  ];

  return (
    <section id="diferenciais" className="py-24 bg-feenex-blue relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
          backgroundSize: '40px 40px'
        }}></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-feenex-gold/20 rounded-full mb-4">
            <span className="text-sm font-semibold text-feenex-gold uppercase tracking-wider">Por Que Feenex</span>
          </div>
          <h4 className="text-4xl lg:text-5xl font-bold text-white mb-6">
            <a href="#diferenciais" className="hover:text-feenex-gold transition-colors">
              Diferenciais que Garantem Sua Tranquilidade
            </a>
          </h4>
          <p className="text-lg text-feenex-white/80 max-w-3xl mx-auto">
            Combinamos expertise técnica, segurança jurídica e transparência para entregar soluções que geram resultados sustentáveis.
          </p>
        </div>

        {/* Differentials Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {differentials.map((item, index) => (
            <div 
              key={index}
              className="bg-white/5 backdrop-blur-sm rounded-lg p-8 border border-white/10 hover:bg-white/10 transition-all duration-300"
            >
              <div className="w-14 h-14 bg-feenex-gold/20 rounded-lg flex items-center justify-center mb-6">
                <i className={`${item.icon} text-2xl text-feenex-gold`}></i>
              </div>
              
              <h3 className="text-xl font-bold text-white mb-4">
                {item.title}
              </h3>
              
              <p className="text-feenex-white/70 leading-relaxed text-sm">
                {item.description}
              </p>
            </div>
          ))}
        </div>

        {/* Trust Indicators */}
        <div className="mt-20 pt-16 border-t border-white/10">
          <div className="grid md:grid-cols-4 gap-8 text-center">
            <div>
              <div className="text-3xl font-bold text-feenex-gold mb-2">15+</div>
              <div className="text-sm text-feenex-white/70 uppercase tracking-wider">Anos de Mercado com a Monetali</div>
            </div>
            <div>
              <div className="text-3xl font-bold text-feenex-gold mb-2">Zero</div>
              <div className="text-sm text-feenex-white/70 uppercase tracking-wider">Autuações Fiscais</div>
            </div>
            <div>
              <div className="text-3xl font-bold text-feenex-gold mb-2">100%</div>
              <div className="text-sm text-feenex-white/70 uppercase tracking-wider">Clientes Satisfeitos</div>
            </div>
            <div>
              <div className="text-3xl font-bold text-feenex-gold mb-2">AAA</div>
              <div className="text-sm text-feenex-white/70 uppercase tracking-wider">Rating de Crédito</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
